import { useContactManagementTranslation } from '../../../../ui/hooks';
import { NavigationContext } from '@juvare/common-web-ui/NavigationContext';
import { FormControlLabel, Switch } from '@mui/material';
import React from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router';
export const showAccountsIManageFilterName = 'showAccountsIManage';
export const AccountsIManageSwitch = () => {
    const { t } = useContactManagementTranslation();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const location = useLocation();
    const navigationContext = React.useContext(NavigationContext);
    const showAccountsIManage = searchParams.get(showAccountsIManageFilterName) === 'true';
    return (React.createElement(FormControlLabel, { sx: { mt: -2, mb: -2 }, label: t('panels.organizations.showAccountsIManage'), control: React.createElement(Switch, { checked: showAccountsIManage, onChange: (_event, checked) => {
                const newSearchParams = new URLSearchParams(searchParams);
                if (checked) {
                    newSearchParams.set('showAccountsIManage', 'true');
                }
                else {
                    newSearchParams.delete('showAccountsIManage');
                }
                navigationContext.navigate(() => {
                    navigate({ pathname: '.', search: newSearchParams.toString() }, { state: location === null || location === void 0 ? void 0 : location.state, replace: true });
                });
            } }) }));
};
